import React, { Component, Fragment } from 'react'
import DragContainerUI from "../../ddTxtImg/ui/DragContainerUI"
import WordOnImgDropItemContainerUI from "./WordOnImgDropItemContainerUI"


class WordOnImgActvityUI extends Component {

    render=()=>{

        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state


        return(
            <Fragment>
                <DragContainerUI activity={activity} quizViewer={quizViewer} />
                <WordOnImgDropItemContainerUI activity={activity} quizViewer={quizViewer} /> 
            </Fragment>
        )
    }
}

export default WordOnImgActvityUI